import { once } from '../shared/once';

import { getPlan } from './get-plan';

export const getPlanByQueryParam = once<Promise<any>>(async () => {
    const urlParams = new URLSearchParams(window.location.search);
    const planCode = urlParams.get(`mh-plan-code`);
    return getPlan(`code-${planCode}`);
});
